exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.overlay-text-input{width:100%;height:28px;padding:6px}", ""]);

// exports
